export default "/_next/static/images/how-it-works-1x-dd6c6cd5ddd8cd702fe805bc0569192a.jpg";